import React from 'react';

import PropTypes from 'prop-types';

import { useIntl } from '../../../../plugins/publicis-gatsby-plugin-i18n';
import { SearchIcon } from '../../../Atoms/Icons/Icons';

import './SearchHeader.scss';

const SearchHeader = ({ openSearchPopin, onToggleOpenPropsFunc }) => {
  const intl = useIntl();

  const onOpenSearchBar = (e) => {
    e.preventDefault();
    onToggleOpenPropsFunc(true);
    document.body.classList.remove('scroll-down');
    document.body.classList.add('popin_open');
  };
  return (
    <div className="searchHeader">
      <a href="#" className="search_opener"
        onClick={onOpenSearchBar}
        aria-expanded={openSearchPopin ? 'true' : 'false'}
        aria-label={intl.formatMessage({ id: 'ariaLabel.open_searchbar' })}
      >
        <div className="center">
          <SearchIcon />
          <span>{intl.formatMessage({ id: 'search.cta.search' })}</span>
        </div>
      </a>
    </div>
  );
};

SearchHeader.propTypes = {
  intl: PropTypes.object
};

export default SearchHeader;
